export const socialsData = {
    // github: 'https://github.com/',
    facebook: 'https://www.facebook.com/rattan.datta',
    linkedIn: 'https://www.linkedin.com/in/rattan-datta-663aa917/',
    instagram: 'https://www.instagram.com/rattankdatta/',
    // codepen: 'https://codepen.io/',
    twitter: 'https://x.com/RattanDatta',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // medium: 'https://medium.com/@',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    youtube: 'https://www.youtube.com/@meritmerit401'
}